import { lazy } from 'react';
const DeleteLogs = lazy(() => import('../pages/audit/DeleteLogs'));

const auditRoutes = [
  {
    path: '/audit/delete-logs',
    element: <DeleteLogs />,
    roles: ['Admin', 'SuperAdmin']
  }
];

export default auditRoutes;
